/**
 * example
 * <print-button on-click="onClick()"></print-button>
 */

angular.module('inspinia').directive('printButton', function () {
  return {
    restrict: 'E',
    scope: {
      onClick: '&',
    },
    templateUrl: '/manage/src/view/directive/button/print_button.html' + '?' + new Date().getTime(),
    link: function ($scope, _element, _attrs, _ctrl) {
      $scope.onClick;
    },
  };
});
